import { render } from "./BenefitComponent.vue?vue&type=template&id=d7dff1e2"
import script from "./BenefitComponent.vue?vue&type=script&lang=js"
export * from "./BenefitComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Benefit/BenefitComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7dff1e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7dff1e2', __exports__)) {
    api.reload('d7dff1e2', __exports__)
  }
  
  module.hot.accept("./BenefitComponent.vue?vue&type=template&id=d7dff1e2", () => {
    api.rerender('d7dff1e2', render)
  })

}


export default __exports__